
<div class="wrapper page-heading page-heading-header-bg">
    <div class="row page-heading-left">
        <div class="col-xs-6" >
            <h1 [i18n]="'df-management.df-admin.title'" (click)="goBackAdmin()"></h1>
        </div>
    </div>
</div>
    <div class="bulk-calendar-data">
        <div class="header-container">
            <h2 class="bluk-calendar-title" [i18n]="'df-management.df-admin.calendar.singleCalendarData'"></h2>
        </div>
        <div class="year-buffer">
            <span class="selectedYear" [i18n]="[{target: 'innerHTML', key: 'df-management.df-admin.calendar.fiscalYear', params: {selectedYear: selectedYear}}]">
                 {{ selectedYear }}
            </span>
            <div class="buffer-days">
                <label for="buffer-days" [i18n]="'df-management.df-admin.calendar.bufferDays'"></label>
                <div class="data-filter">
                        <input
                            class="buffer-input"
                            type="number" 
                            [(ngModel)]="bufferDays" 
                            (input)="voucherDatesCalculation()"
                            [i18n]="[{target: 'attribute:placeholder', key: 'df-management.df-admin.calendar.selectDays'}]"
                            [min]="1"
                            [max]="7"
                            (keydown)="keyValidations($event)" 
                        />
                  </div>
            </div>
        </div>
        <table>
            <thead>
                <tr>
                    <th [i18n]="'df-management.df-admin.calendar-heading.reportingMonth'"></th>
                    <th [i18n]="'df-management.df-admin.calendar-heading.startDate'"></th>
                    <th [i18n]="'df-management.df-admin.calendar-heading.endDate'"></th>
                    <th [i18n]="'df-management.df-admin.calendar-heading.numberOfDays'"></th>
                    <th [i18n]="'df-management.df-admin.calendar-heading.jobRunDate'"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let month of months; let i = index">
                    <td>{{ month.month }}</td>
                    <td><input type="date" [(ngModel)]="month.monthStartDate" (change)="updateNumberOfDays(month, i)" [max]="month.monthEndDate || ''" ></td>
                    <td><input type="date" [(ngModel)]="month.monthEndDate" (change)="updateNumberOfDays(month, i)" [min]="month.minEndDate" [min]="month.monthStartDate"></td>
                    <td><span>{{ month.numberOfDays }}</span></td>
                    <td><input type="date" [(ngModel)]="month.voucherUpdateDate" readonly></td>
                </tr>                              
            </tbody>
        </table>
        <div class="actions">
            <a  class="cancel-link" (click)="cancel()" [i18n]="'df-management.df-admin.calendar.cancel'"></a>
            <button *ngIf="formType === 'OnBoardCountry'"class="save-continue-button" (click)="saveCalendar()" [i18n]="'df-management.df-admin.calendar.svaeAndContinue'" [disabled]="!areAllDatesFilled()"></button>
            <button *ngIf="formType === 'ViewCountry'"class="save-continue-button" (click)="saveCalendarToDatabase()" [i18n]="'df-management.df-admin.calendar.save'" [disabled]="!areAllDatesFilled()"></button>
        </div>
    </div>

    <div class="overlay" *ngIf="isDataSavedPopup">
        <div class="download-popup">
            <i class="fa fa-check-circle download-success-button"></i>
            <h4 class="sucessHeading" [i18n]="'df-management.form.file.success'"></h4>
            <div class="download-content">
                <span [i18n]="'df-management.df-admin.calendar.uploadedPopup'"></span>
            </div>
            <div class="form-group">
                <button class="btn btn-i btn-primary btn-lg button" type="submit" (click)="confirmDownloadReportButton()">
                    <span [i18n]="'df-management.form.model-popup.button'"></span>
                </button>
            </div>
        </div>
    </div>



